/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Alert_SuccessInputs */

const en_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent successfully!`)
};

const ar_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إرسال الرسالة بنجاح!`)
};

const bn_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা পাঠানো হয়েছে!`)
};

const de_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht erfolgreich gesendet!`)
};

const es_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Mensaje enviado exitosamente!`)
};

const fr_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message envoyé avec succès !`)
};

const pt_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem enviada com sucesso!`)
};

const zh_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息发送成功！`)
};

const tr_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj başarıyla gönderildi!`)
};

const ru_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение успешно отправлено!`)
};

const pl_form_alert_success = /** @type {(inputs: Form_Alert_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość wysłana pomyślnie!`)
};

/**
* | output |
* | --- |
* | "Message sent successfully!" |
*
* @param {Form_Alert_SuccessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_alert_success = /** @type {((inputs?: Form_Alert_SuccessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Alert_SuccessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_alert_success(inputs)
	if (locale === "bn") return bn_form_alert_success(inputs)
	if (locale === "de") return de_form_alert_success(inputs)
	if (locale === "es") return es_form_alert_success(inputs)
	if (locale === "fr") return fr_form_alert_success(inputs)
	if (locale === "pt") return pt_form_alert_success(inputs)
	if (locale === "zh") return zh_form_alert_success(inputs)
	if (locale === "tr") return tr_form_alert_success(inputs)
	if (locale === "ru") return ru_form_alert_success(inputs)
	if (locale === "pl") return pl_form_alert_success(inputs)
	return en_form_alert_success(inputs)
});